import { useEffect, useState } from "react";
import styled from "styled-components";
import Breakpoints, {devices} from "../../config/Breakpoints";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import SectionTitle from "./sectionTitle";

const CarouselDesktop = styled(Carousel)`
    overflow: hidden;

    @media ${Breakpoints.max.sm} {
        display: none;
    }
`;

const CarouselMobile = styled(Carousel)`
    overflow: hidden;
    margin-left: -1.5rem;
    margin-right: -1.5rem;

    .react-multi-carousel-track {
        padding-left: .75rem;
        padding-right: .75rem;
    }

    &.oneItem {
        .react-multi-carousel-track {
            transform: translate3d(0,0,0) !important;
        }
    }

    @media ${Breakpoints.md} {
        display: none;
    }
`;

const ImageList = ({sectionData}) => {
    const [largeImgList, setLargeImgList] = useState([]);
    const [smallImgList, setSmallImgList] = useState([]);
    const [carouselDef, setCarouselDef] = useState({});

    useEffect(() => {
        console.log(sectionData, sectionData.title);
        let lgImgs = sectionData.images.filter((item => item.title.indexOf('__lg') > -1));
        let smImgs = sectionData.images.filter((item => item.title.indexOf('__sm') > -1));
        
        console.log(lgImgs, smImgs);
        
        setLargeImgList(lgImgs);
        setSmallImgList(smImgs);

        setCarouselDef({
            desktop: {
                breakpoint: {max: 9999, min: devices.md},
                items: lgImgs.length > 2 ? 3 : lgImgs.length
            },
            mobile: {
                breakpoint: {max: devices.md-1, min: 0},
                items: 1,
                partialVisibilityGutter: 50
            }
        });
        console.log('aqui');
    },[sectionData]);

    const CarouselImage = styled.img`
        width: 100%;
        height: auto;
        aspect-ratio: ${largeImgList.length > 2 ? '464/432' : largeImgList.length === 2 ? '708/432' : '1440/432'};
        object-fit: contain;
        border-radius: 1rem;
        margin: 0 .75rem;

        @media ${Breakpoints.max.sm} {
            aspect-ratio: 464/432;
            margin: 0;
        }
    `;

    return (
        <>
            <SectionTitle>{sectionData.title}</SectionTitle>
            {largeImgList.length > 0 && (
                <CarouselDesktop
                    responsive={carouselDef}
                    keyBoardControl={true}
                >
                    {largeImgList.map((item) => (
                        <div style={{margin: '0 .75rem'}} key={item.title}><CarouselImage src={item.url} alt={item.description || ''} /></div>
                    ))}
                </CarouselDesktop>
            )}
            {smallImgList.length > 0 && (
                <CarouselMobile
                    responsive={carouselDef}
                    swipeable={true}
                    draggable={true}
                    removeArrowOnDeviceType={["mobile"]}
                    partialVisible={true}
                    className={smallImgList.length === 1 ? 'oneItem' : ''}
                >
                    {smallImgList.map((item) => (
                        <div style={{margin: '0 .75rem'}} key={item.title}><CarouselImage src={item.url} alt={item.description || ''} /></div>
                    ))}
                </CarouselMobile>
            )}
        </>
    );
}

export const ImageListStyles = `
    
`;

export default ImageList;